import {Injectable} from '@angular/core';
import {CrudRepository, toMultipleSelectItem } from '@abydos-angular/store';
import {coalesce, RestResponse, LabelValueVO} from '@abydos-angular/core';
import {map, share, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {ApplicationVO,  ApplicationListVO} from './application.interfaces';
import {ApplicationRestService} from '../api/application-rest.service';

@Injectable()
export class ApplicationRepository extends CrudRepository<ApplicationVO, ApplicationListVO> {

    constructor(private applicationRestService: ApplicationRestService) {
        super(applicationRestService);
    }

    override initSelectItems(): Observable<Map<string, LabelValueVO[]>> {
        return coalesce(this.getCachedSelectItem('initSelectItems'),
            forkJoin([
                of(RestResponse.create({status:'OK', data:[]}))
            ])
        .pipe(
            map(([emptyResponse]) => {
                return {
                    empty: emptyResponse
                };
          })
          , toMultipleSelectItem(['empty'])
          , share()
          , tap((itemMap) => {
            this.selectItemCache.set('initSelectItems', itemMap);
          }))
      )!;
    }
}
